<template>
  <v-card class="provider-card" :class="$vuetify.breakpoint.smAndDown && cardData.providersCount > 1 ? 'px-3' : ''">
    <div v-if="$vuetify.breakpoint.smAndDown && cardData.providersCount > 1">
      <div :style="{position: 'absolute', top: 'calc(51% - 24px)', left: '-10px'}">
        <v-btn flat icon @click="() => $emit('left')">
          <v-icon>keyboard_arrow_left</v-icon>
        </v-btn>
      </div>
      <div :style="{position: 'absolute', top: 'calc(51% - 24px)', right: '-10px'}">
        <v-btn flat icon @click="() => $emit('right')">
          <v-icon>keyboard_arrow_right</v-icon>
        </v-btn>
      </div>
    </div>
    <v-card-title primary-title style="display: block">
      <div>
        <h3 :class="`headline ${cardData.providerColor}--text`">{{ cardData.providerName }}</h3>
      </div>
      <div>{{ cardData.comment }}</div>
      <div v-if="timeLeft !== 'No more Orders'">
        <span v-t="'dishesContainer.timeLeft'" />
        <span>{{ timeLeft }}</span>
      </div>
      <span v-else-if="disableDishes()" v-t="'dishesContainer.noMoreOrders'" />
    </v-card-title>
  </v-card>
</template>

<script>
import moment from 'moment';

export default {
  name: 'ProviderCard',
  props: {
    cardData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      timeLeft: '...',
      interval: null,
    };
  },
  mounted() {
    this.interval = setInterval(() => {
      if (!this.cardData || !this.cardData.orderUntil) {
        this.timeLeft = '';
        return;
      }
      const orderUntil = moment(this.cardData.orderUntil);
      const today = moment();
      const daysDiff = orderUntil.diff(today, 'days');
      if (today > orderUntil) {
        this.timeLeft = 'No more Orders';
      } else if (daysDiff > 0) {
        this.timeLeft = `> ${this.$tc('dishesContainer.days', daysDiff, { count: daysDiff })}`;
      } else {
        const timeDiff = moment(orderUntil.diff(today)).utc();

        this.timeLeft = timeDiff.format('HH:mm:ss');
      }
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods:
   {
     disableDishes() {
       this.$emit('disableDishes');
       return true;
     },
   },
};
</script>

<style scoped>
.time-left {
  position: absolute;
  top: 26px;
}
</style>
